import React from 'react'
import {callIfFunction, getColor} from '@startlibs/utils'
import {Navbar} from '../../components/Navbar'
import {Card} from '../../components/PageLayout'
import {Icon} from '@startlibs/components'
import {InfoBox} from '../../components/InfoBox'
import {lazyProviderInfo} from '../../components/WithProvider'
import styled from 'styled-components'
import {WithLazyResource} from '../../hooks/useSuspense'
import {FormattedMessage} from "react-intl";

const ExpiredLinkWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  max-width: 400px;
  ${Card} {
    margin-bottom: 1rem;
    padding-bottom: 4rem;
  }
  ${Icon} {
    font-size: 5rem;
    color: ${getColor('gray180')};
  }
  h1 {
    font-size: 18px;
    margin: 1rem auto;
    color: ${getColor('main')};
  }
  p {
    margin: 0 .25rem;
  }
`

export class ProviderReleaseError extends React.Component {

  constructor(props) {
    super(props)
    this.state = {hasError: false, locked: false}

  }

  static getDerivedStateFromError(error) {
    // let errorString = ''+error
    // if(errorString.includes('Cannot read property \'jwt\'')){
    //   return {hasError: true}
    // }
    const errorData = error && callIfFunction(error.get)
    if (errorData && errorData.ignoreError) {
      return {withoutUX: true}
    }
    const status =  errorData && errorData[1] && errorData[1].status
    if (status === 404 || status === 401 ) {
    // Update state so the next render will show the fallback UI.
      return {hasError: true}
    }
    if (status === 569) {
      // Update state so the next render will show the fallback UI.
      return {locked: true}
    }
  }

  closeDialog = () => {
    this.setState({closingDialog: true})
    setTimeout(() => window.parent.postMessage(JSON.stringify({type: 'removeIframe'}), '*'), 300)
  }

  render() {
    if (this.state.withoutUX) {
      return null
    }

    if (this.state.locked) {
      return <>
        <Navbar/>
        <ExpiredLinkWrapper>
          <Card>
            <Icon icon="warning"/>
            <h1><FormattedMessage
              defaultMessage="It's no longer possible to submit medical records"
              description="Provider release locked, error title"
            /></h1>
            <p><FormattedMessage
              defaultMessage="This request is no longer accepting new medical records"
              description="Provider release locked, error message"
            /></p>
          </Card>
          <InfoBox lightBlue>
            <p><FormattedMessage
              defaultMessage="Need help providing patient medical records?"
              description="Provider release locked, help question"
            /></p>
            <p><strong><WithLazyResource value={lazyProviderInfo}>{providerInfo =>
              <FormattedMessage
                defaultMessage="Please contact {phoneNumber}"
                description="Provider release locked, help message"
                values={{phoneNumber: providerInfo?.address?.phoneNumber}}
              />
            }</WithLazyResource>.</strong></p>
          </InfoBox>
        </ExpiredLinkWrapper>
      </>
    }

    if (this.state.hasError) {
      return <>
        <Navbar/>
        <ExpiredLinkWrapper>
          <Card>
            <Icon icon="warning"/>
            <h1><FormattedMessage
              defaultMessage="This link has expired or is not valid."
              description="Provider release error title"
            /></h1>
            <p><FormattedMessage
              defaultMessage="The link you are trying to access is not valid or it has reached its expiration date."
              description="Provider release error message"
            /></p>
          </Card>
          <InfoBox lightBlue>
            <p><FormattedMessage
              defaultMessage="Need help providing patient medical records?"
              description="Provider release error help question"
            /></p>
            <p><strong><WithLazyResource value={lazyProviderInfo}>{providerInfo =>
              <FormattedMessage
                defaultMessage="Please contact {phoneNumber}."
                description="Provider release error help message"
                values={{phoneNumber: providerInfo.address.phoneNumber}}
              />
            }</WithLazyResource></strong></p>
          </InfoBox>
        </ExpiredLinkWrapper>
      </>
    }

    return this.props.children
  }
}